import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLista'
})
export class FormatListaPipe implements PipeTransform {

  transform(value: any) {
    value += '\n';

    let formatted = value
      .replace(/(\n)/g, '<br>')
      .replace(/\*\*(.*?)\*\*/gm, '<p><strong>$1</strong></p>')
      .replace(/\*\s(.*?\<br\>?)/gi, '<li>$1</li>')
      .replace(/\<br\>\<br\>/g, '');

    // Agrupar <li> dentro de <ul>
    formatted = formatted.replace(/(<li>.*?<\/li>)+/g, (match: any) => {
      return `<ul>${match}</ul>`;
    });

    return formatted;
  }

}
